exports.typeName = {
    cashPayment : 'cash',
    stripePayment : 'stripe_terminal',
    manualPayment : 'authorized_net',
    Support : "Online",
    storeCredit : 'store-credit',
    payconiq : 'payconiq',
    UPISupport : 'UPI'
}   
